const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9142 12.8541C12.8337 12.1312 13.505 11.1397 13.8347 10.0174C14.1643 8.89516 14.1359 7.69807 13.7534 6.59272C13.3709 5.48737 12.6534 4.52875 11.7007 3.85025C10.7479 3.17175 9.60734 2.80713 8.43768 2.80713C7.26802 2.80713 6.12746 3.17175 5.17471 3.85025C4.22196 4.52875 3.50441 5.48737 3.12193 6.59272C2.73945 7.69807 2.71105 8.89516 3.04069 10.0174C3.37033 11.1397 4.04161 12.1312 4.96112 12.8541C3.48247 13.4576 2.17579 14.417 1.15721 15.6471C0.997252 15.8375 0.919488 16.0837 0.941026 16.3314C0.962563 16.5792 1.08164 16.8082 1.27205 16.9682C1.46247 17.1282 1.70863 17.2059 1.95639 17.1844C2.20414 17.1628 2.43319 17.0438 2.59315 16.8534C3.66268 15.5799 5.54706 14.0627 8.43768 14.0627C11.3283 14.0627 13.2127 15.5799 14.2822 16.8534C14.4422 17.0438 14.6712 17.1628 14.919 17.1844C15.1667 17.2059 15.4129 17.1282 15.6033 16.9682C15.7937 16.8082 15.9128 16.5792 15.9343 16.3314C15.9559 16.0837 15.8781 15.8375 15.7181 15.6471C14.6998 14.4168 13.3931 13.4573 11.9142 12.8541ZM4.68768 8.43773C4.68768 7.69605 4.90761 6.97103 5.31967 6.35434C5.73172 5.73766 6.31739 5.25701 7.00262 4.97318C7.68784 4.68935 8.44184 4.61509 9.16927 4.75978C9.8967 4.90448 10.5649 5.26163 11.0893 5.78608C11.6138 6.31053 11.9709 6.97871 12.1156 7.70614C12.2603 8.43357 12.1861 9.18757 11.9022 9.87279C11.6184 10.558 11.1378 11.1437 10.5211 11.5557C9.90438 11.9678 9.17936 12.1877 8.43768 12.1877C7.44344 12.1867 6.49021 11.7913 5.78717 11.0882C5.08413 10.3852 4.68871 9.43197 4.68768 8.43773Z",
    fill: "#3E3D3D",
    style: {
      fill: "#3E3D3D",
      fill: "color(display-p3 0.2431 0.2392 0.2392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15C10 12.2386 12.2386 10 15 10C17.7614 10 20 12.2386 20 15C20 17.7614 17.7614 20 15 20C12.2386 20 10 17.7614 10 15Z",
    fill: "#FFF8E7",
    style: {
      fill: "#FFF8E7",
      fill: "color(display-p3 1.0000 0.9706 0.9071)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15C11 12.7909 12.7909 11 15 11C17.2091 11 19 12.7909 19 15C19 17.2091 17.2091 19 15 19C12.7909 19 11 17.2091 11 15ZM15 10C12.2386 10 10 12.2386 10 15C10 17.7614 12.2386 20 15 20C17.7614 20 20 17.7614 20 15C20 12.2386 17.7614 10 15 10ZM17.0844 14.7153C17.3043 14.8417 17.3043 15.1579 17.0844 15.2844L13.7442 17.2053C13.5243 17.3318 13.2493 17.1737 13.2493 16.9207V13.0789C13.2493 12.826 13.5243 12.6679 13.7442 12.7944L17.0844 14.7153Z",
    fill: "#FFB81F",
    style: {
      fill: "#FFB81F",
      fill: "color(display-p3 1.0000 0.7213 0.1200)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.08472ed3b9d9dc3989c5618b6633bc48.svg";
export { ForwardRef as ReactComponent };